// extracted by mini-css-extract-plugin
module.exports = {"summary":"PostSummary_summary__shLfg","title":"PostSummary_title__8_lW4"};